import { Theme } from '@mui/material';
// forced white on LIO; dark page palettes keep the theme's menu paper, since the items use the theme's text color
const onLio = (value: string) => (theme: Theme) => (theme.palette.theme === 'lio' ? value : undefined);

export const paperProps = {
  PaperProps: {
    sx: {
      backgroundColor: onLio('#FFF !important'), // TODO clean up hex codes
      color: onLio('#000 !important'), // TODO clean up hex codes
      maxHeight: '300px',
      '.base-Popper-root': {
        backgroundColor: onLio('#FFF !important'), // TODO clean up hex codes
      },
    },
  },
};

export const boxStyles = { minWidth: '120px', width: '100%', display: 'flex', justifyContent: 'center' };
